import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { StyledHeader, HeaderText, ClearButton, CloseIcon } from './Styles';
import { FilterNames } from '../../../_shared/types/trade';

const propTypes = {
  clearFilter: PropTypes.func.isRequired,
  isEditing: PropTypes.bool.isRequired,
  activeFilter: PropTypes.objectOf(PropTypes.any).isRequired
};

const Header = ({ isEditing, clearFilter, activeFilter }) => {
  const showClearBtn = () => {
    return isEditing || activeFilter?.id !== FilterNames.all.id;
  };

  return (
    <StyledHeader>
      <HeaderText>
        <FormattedMessage id="list.filters.headertext" />
      </HeaderText>
      {showClearBtn() && (
        <ClearButton
          testId="clear-filters"
          onClick={() => clearFilter(FilterNames.all)}
        >
          <FormattedMessage id="list.filters.clear" />
          <CloseIcon />
        </ClearButton>
      )}
    </StyledHeader>
  );
};

Header.propTypes = propTypes;

export default Header;
